import { useState } from "react";
import { toast } from "sonner";

import { descargarPdfDeCotizacionRequest } from "@/lib/informes";

/**
 * La descarga del documento de cotización, separada del botón que la dibuja.
 *
 * Existe para que un ítem de MENÚ —la fila del listado de informes en proceso—
 * baje el mismo archivo con el mismo aviso de error, sin copiar la lógica: dos
 * copias de este `try` terminarían diciendo cosas distintas ante el mismo
 * fallo.
 */
export function useDescargarCotizacion(informeId: number) {
  const [descargando, setDescargando] = useState(false);

  async function descargar() {
    setDescargando(true);

    try {
      await descargarPdfDeCotizacionRequest(informeId);
    } catch {
      // El motivo real no le sirve a quien mira la pantalla: o la cotización
      // todavía no tiene documento, o la sesión venció. Las dos se resuelven
      // igual —recargar y reintentar— así que el mensaje es uno solo.
      toast.error("No pudimos descargar el documento. Recargá la página y volvé a intentarlo.");
    } finally {
      setDescargando(false);
    }
  }

  return { descargando, descargar };
}
